import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class AppEvent {
    window: any;
    listeners: any[] = [];
    parent: any;

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.window = this.document.defaultView;

        if (!this.window.unifield)
            this.window.unifield = {
                addEventListener: this.addEventListener
            };
        else {
            this.window.unifield.addEventListener = this.addEventListener;
        }

        this.parent = parent;
        parent.postMessage({ name: "viewer_object_clicked", payload: { message: "hello" } }, "*")
    }

    public emit(name: string, payload: any) {
        parent.postMessage({ name, payload }, "*")

        this.listeners.forEach(l => {
            if (l.name == name) l.cb(payload);
        })
    }

    addEventListener(name: string, cb: (payload: any) => void) {
        this.listeners.push({ name, cb })
    }
}